<template>
  <v-menu
      ref="picker"
      v-model="menu_model"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="model"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          style="width: 100%;"
      />
    </template>
    <v-time-picker
        v-model="model"
        :min="minTime"
        :max="maxTime"
        format="24hr"
    >
      <v-btn
          flat
          color="primary"
          @click="menu_model=false"
      >
        Cancel
      </v-btn>
      <v-btn
          style="color:white; background-color: rgb(51,82,128);"
          @click="$refs.picker.save(model)"
      >
        OK
      </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "InlineTimePicker",
  props: {
    label: String,
    model: String,
    minTime: String,
    maxTime: String
  },
  data() {
    return {
      menu_model: null
    }
  },
  methods: {
    async sync() {
      this.$emit('update:model', this.model);
    }
  },
  watch: {
    model: {
      handler () {
        this.sync()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>